module.exports = __webpack_public_path__ + "assets/img/LJ-Hooker-eBook-w960.10053fd0.jpg";